var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getDateTimeByFormat, personNameInitials, removeHashRevokeUserEmail, } from '@/shared/utils/helpers';
import { Component, Vue, Watch } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import { connect } from '@/overmind';
import { translateRole } from '@/shared/utils/translate';
let UsersDetailContainer = class UsersDetailContainer extends Vue {
    constructor() {
        super(...arguments);
        this.translateRole = translateRole;
        this.edittingName = false;
        this.edittingEmail = false;
        this.edittingWhatsapp = false;
        this.edittingStatus = false;
        this.edittingRole = false;
        this.openInputFile = false;
        this.edittingImg = false;
        this.imgFile = null;
        this.tes = null;
        this.consumptions = [];
        this.roleOptions = [
            { label: 'Gerente', value: 'manager' },
            { label: 'Coordenador', value: 'coordinator' },
            { label: 'Prospector', value: 'prospector' },
            { label: 'CS', value: 'customer_success' },
        ];
        this.statusOptions = [
            { label: 'Ativo', value: 'active' },
            { label: 'Inativo', value: 'inactive' },
        ];
        this.name = '';
        this.whatsappNumber = '';
        this.email = '';
        this.role = '';
    }
    get user() {
        return this.$store.getters['admin/get_selected_sub_user'];
    }
    beforeMount() {
        this.setInputs();
    }
    setInputs() {
        if (this.user) {
            this.whatsappNumber = this.user.whatsapp;
            this.role = this.user.role;
            this.name = this.user.name;
            this.email = this.user.email;
        }
    }
    get authorNameInitials() {
        return personNameInitials(this.name);
    }
    userEmail() {
        if (this.user.active)
            return removeHashRevokeUserEmail(this.email);
        return this.email;
    }
    userStatus() {
        return this.user.active ? 'Inativo' : 'Ativo';
    }
    get userCreatedAt() {
        if (this.user.created_at) {
            return getDateTimeByFormat(new Date(this.user.created_at), 'dddd, D [de] MMMM [de] YYYY');
        }
        return '';
    }
    get userUpdatedAt() {
        if (this.user.updated_at) {
            return getDateTimeByFormat(new Date(this.user.updated_at), 'dddd, D [de] MMMM [de] YYYY');
        }
        return '';
    }
    hasClicks(consumption) {
        return consumption && consumption.type === 'click';
    }
    hasUnlimitedClicks(consumption) {
        return consumption && consumption.type === 'unlimited_click';
    }
    hasExports(consumption) {
        return consumption && consumption.type === 'export';
    }
    async changeName(evt) {
        this.edittingName = true;
        const name = evt.target.value.trim();
        await this.changeAttribute({ name });
        this.edittingName = false;
    }
    async changeEmail(evt) {
        this.edittingEmail = true;
        const email = evt.target.value.trim();
        await this.changeAttribute({ email });
        this.edittingEmail = false;
    }
    async changeWhatsappNumber(evt) {
        this.edittingWhatsapp = true;
        const whatsappNumber = evt.target.value.trim();
        await this.changeAttribute({ whatsappNumber });
        this.edittingWhatsapp = false;
    }
    async changeRole(role) {
        this.edittingRole = true;
        await this.changeAttribute({ role });
        this.edittingRole = false;
    }
    async changeStatus(status) {
        this.edittingStatus = true;
        if (status === 'inactive' && this.user.active) {
            await this.$store.dispatch('admin/inactive_user', this.user.id);
        }
        else if (status === 'active' && !this.user.active) {
            await this.$store.dispatch('admin/active_user', this.user.id);
        }
        this.edittingStatus = false;
    }
    async changeAttribute(obj) {
        await this.$store.dispatch('admin/update_sub_users', {
            id: this.user.id,
            name: obj.name,
            email: obj.email,
            role: obj.role,
            whatsappNumber: obj.whatsappNumber,
        });
    }
};
__decorate([
    Watch('user')
], UsersDetailContainer.prototype, "setInputs", null);
UsersDetailContainer = __decorate([
    Component(connect(({ state, actions }) => ({
        adminActions: actions.admin,
        adminState: state.admin,
        newAdminState: state.newAdmin,
        newAdminActions: state.newAdmin,
    }), {
        components: {
            Input,
        },
    }))
], UsersDetailContainer);
export default UsersDetailContainer;
